import { render, staticRenderFns } from "./authenticationConfirm.vue?vue&type=template&id=175855da&scoped=true"
import script from "./authenticationConfirm.vue?vue&type=script&lang=js"
export * from "./authenticationConfirm.vue?vue&type=script&lang=js"
import style0 from "./authenticationConfirm.vue?vue&type=style&index=0&id=175855da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175855da",
  null
  
)

export default component.exports